import PartnerLogo from '../PartnerLogo';

import * as style from './style.module.css';

const PartnersList = ({ partners = [] }) => <div className={style.sponsors}>
    {partners.map((sponsor) => (
        <PartnerLogo type={sponsor} key={sponsor} />
    ))}
</div>


export default PartnersList;